export default "__VITE_ASSET__DQNTA4qt__"